import React from 'react';
export const OptionColorsSkeleton = ({ nbItems }) => (React.createElement("div", { className: "mt:28 d:flex fd:column" },
    React.createElement("div", { className: "d:flex mb:16" },
        React.createElement("div", { className: "skeleton fz:14 h:lh w:1/5" })),
    React.createElement("div", { className: "d:flex fxw:wrap m:-6" }, [...Array(nbItems)].map((v, i) => (React.createElement("div", { className: "m:6 w:56 w:64:xl-up pb:28 pb:32:xl-up", key: i },
        React.createElement("div", { className: "bdrs:1 m:0 w:100p pos:r" },
            React.createElement("div", { className: "image-wrapper w:100p skeleton" }),
            React.createElement("div", { className: "pos:a l:0 t:100p w:100p mt:6" },
                React.createElement("div", { className: "fz:10 lh:1.1 fz:12:xl-up w:2/3 mx:auto h:lh skeleton" })))))))));
